/*
 * � 2020 Microsoft. All rights reserved.
 */

define('Solitaire/GameModes/PyramidGameMode',['Solitaire/GameModes/GameModeBase',
        'Solitaire/GameModes/IGameMode',
        'Solitaire/Solitaire',
        'Solitaire/SolitaireGameMode',
        'SolitaireShared/PyramidLogic/PyramidAuthority',
        'SolitaireShared/PyramidTemplate/PyramidWindowsTemplate',
        'SolitaireShared/CardLogic/CardAction',
        'Solitaire/GameResult',
        'Solitaire/GameState',
        'Solitaire/SolitaireStatistics',
        'util/SettingsManager'],
    function (GameModeBase, IGameMode, SolitaireGame, SolitaireGameMode, PyramidAuthority, PyramidWindowsTemplate, CardAction, GameResult, GameState, SolitaireStatistics, SettingsManager) {
        "use strict";

        var PyramidGameMode = function () {
            this.initPyramidGameMode();
        };

        PyramidGameMode.constructor = PyramidGameMode;
        PyramidGameMode.prototype = Object.create(GameModeBase.prototype);
        IGameMode.call(PyramidGameMode.prototype);

        PyramidGameMode.prototype.initPyramidGameMode = function () {
            this.Name = SolitaireGameMode.Pyramid;
            this.WaitForAnimationOnHint = false;
            this._cacheDealButtonVisible = false;
        };

        Object.defineProperty(PyramidGameMode.prototype, "TimerOption", {
            get: function () {
                if (GameState.CurrentGame.Authority.IsChallenge) {
                    return GameState.CurrentGame.Authority.TimerEnabled ? IGameMode.TimerSettings.CountDown : IGameMode.TimerSettings.Off;
                }
                var useTimer = SettingsManager.getSetting('pyramid','timer');
                if (useTimer) {
                    return IGameMode.TimerSettings.CountDown;
                }
                return IGameMode.TimerSettings.Off;
            }
        });

        PyramidGameMode.prototype.OnMoveCardButton = function () {
            var action = new CardAction(GameState.CurrentGame.Authority.CardSupply);

            if (GameState.CurrentGame.Authority.CardSupply.GetPile("Stock").Empty) {
                GameState.CurrentGame.SupplyView.GameInputInterpreter.ClickEmptyPile(GameState.CurrentGame.SupplyView.GetPileView("Stock")).Run();
            }
            else {
                action.Parse(["begin", "move", "Stock", "Waste", "1", "end"]);
                if (action.Run()) {
                    var hgltCard = GameState.CurrentGame.SupplyView.GameInputInterpreter.GetHighlightedCard();
                    if (hgltCard != null && hgltCard.Card.Pile.Name == "Waste") {
                        GameState.CurrentGame.SupplyView.GameInputInterpreter.ClearHighlight();
                    }

                    EngineManagers.Sounds.PlaySound("singleCard");
                }
            }
            GameState.CurrentGame.SupplyView.OnMoveCards();
        };


        PyramidGameMode.prototype.IsUpdateDealButtonsVisible = function () {
            GameState.CurrentGame.Authority.GetHint();

            var showButton = GameState.CurrentGame.Authority.AllowDealNextDeck();
            if (GameState.CurrentGame.Authority.CardSupply.IsWaitingForAds || !GameState.CurrentGame.Authority.CardSupply.IsGamePageLoaded)
                showButton = false;

            this._cacheDealButtonVisible = showButton; // && GameState.CurrentGame.Authority.NumDealsLeft() > 0;
            return this._cacheDealButtonVisible;
        };


        PyramidGameMode.prototype.IsUpdateDrawButtonVisible = function () {

            var authority = GameState.CurrentGame.Authority;

            if (authority.PassesThroughDeck >= PyramidAuthority.MaxPassesThroughDeck - 1 &&
                authority.CardSupply.GetPile("Stock").Empty) {
                return false;
            }
            return true;
            //if (_cacheDealButtonVisible && authority != null && authority.PassesThroughDeck < authority.MaxDeals - 1)
            //{
            //    return false;
            //}
            //return !_cacheDealButtonVisible || !(authority.PassesThroughDeck >= PyramidAuthority.MaxPassesThroughDeck - 1
            // || authority.CardSupply.GetPile("Waste").Empty);
        };


        PyramidGameMode.prototype.ConfigureSolitairePage = function (page) {
            this.Supply.UseCumulativeScoring = false;

            setTimeout(function () {
                /*
                 TODO
                 var userData = App.CurrentApp.GameNetClient.GameDataManager.LoadUserDataLocal(
                 GameState.CurrentGame.ActiveMode.Name.toString(), "ShowOutOfMovesTip");

                 if (userData != null && userData.ErrorCode == 0 && userData.Result != null && userData.Result.Value != null)
                 {
                 bool.TryParse(userData.Result.Value, out (GameState.CurrentGame.Authority as PyramidAuthority).ShowOutOfMovesTip);
                 }
                 else
                 {
                 (GameState.CurrentGame.Authority as PyramidAuthority).ShowOutOfMovesTip = true;
                 }
                 */
            }.bind(this), 0);
        }

        PyramidGameMode.prototype.CreateTemplate = function () {
            return new PyramidWindowsTemplate();
        };


        PyramidGameMode.prototype.GetCheatMoves = function () {
            return "G PYRAMID O SECOND 7367031771939848454399196599821169360961682497766870103912390403630112620263346420733351502646325357313737828420552371059029617358314078327925818402349143768 O THIRD 2636350119736703177193984845439919659982116936096168249776687010391239040363011262026334642073335150264632535731373782842055237105902961735831407832792581840 D 61734074451050260284516061045373508919125199387879139242712814305933 B M 33 5 1 M 28 5 1 E B M 32 5 1 M 30 5 1 E B M 31 5 1 M 26 5 1 E B M 34 5 1 M 25 5 1 E B M 29 5 1 M 24 5 1 E M 23 5 1 [1] B M 22 5 1 M 19 5 1 E [4] M 2 3 1 [5] B M 2 5 1 M 17 5 1 E [6] M 2 3 1 [6] B M 2 5 1 M 20 5 1 E [7] B M 3 5 1 M 15 5 1 E [8] M 2 3 1 [9] M 2 3 1 [9] M 2 5 1 [11] M 2 3 1 [13] M 2 3 1 [13] M 2 5 1 [14] M 2 3 1 [15] M 2 3 1 [17] M 2 3 1 [17] B M 2 5 1 M 27 5 1 E [18] M 2 3 1 [19] B M 2 5 1 M 18 5 1 E [19] B M 2 5 1 M 3 5 1 E [20] M 2 3 1 [22] M 2 3 1 [22] B M 2 5 1 M 14 5 1 E [22] B M 2 5 1 M 21 5 1 E [22] B M 3 5 1 M 11 5 1 E [24] M 2 3 1 [25] M 2 3 1 [27] M 2 3 1 [27] M 3 2 -12 [29] M 2 3 1 [29] B M 2 5 1 M 16 5 1 E [29] B M 2 5 1 M 12 5 1 E [29] B M 2 5 1 M 9 5 1 E [31] M 2 3 1 [32] B M 2 5 1 M 13 5 1 E [32] M 10 5 1 [32] B M 3 5 1 M 8 5 1 E [32] N ";
        };

        PyramidGameMode.prototype.HelpDataSource = function () {
            // unsupported? return SimpleIoc.Default.GetInstance<MvvmStructure.Model.PyramidHelpDataSource>();
            return null;
        };

        PyramidGameMode.prototype.ButtonsPostion = function (invertAxis) {
            invertAxis = !!invertAxis;
            throw "TODO";
            /* TODO
             var result = new Dictionary<GameButtons, Vector2>();
             var stockPosition = GetPilePostion("Stock");
             var wastePosition = GetPilePostion("Waste");

             Vector2 position;
             if (!invertAxis)
             {
             position = new Vector2((stockPosition.X + wastePosition.X) * 0.5f, stockPosition.Y);
             result.Add(GameButtons.Deal, position);
             result.Add(GameButtons.Draw, position);
             }
             else
             {
             position = new Vector2(stockPosition.X, (stockPosition.Y + wastePosition.Y) * 0.5f);
             result.Add(GameButtons.Deal, position);
             result.Add(GameButtons.Draw, position);
             }
             return result;
             */
        }

        PyramidGameMode.prototype.GetGameEnd = function () {
            throw "TODO";
            /*
             TODO
             var model = new GameEndModel
             {
             LockIconSourcePath = "Assets/ui/icons/update.png",
             };

             model.AddStatValue("ScoreText", LocalizationManager.GetString("YouScoredColon_Title/Text"), GameEndTileTemplates.Highlighted);
             model.AddStatValue("HighScore", LocalizationManager.GetString("HighScore_Title/Text"), GameEndTileTemplates.Highlighted);
             model.AddStatValue("BoardsCleared", LocalizationManager.GetString("BoardsCleared_Title/Text"));
             model.AddStatValue("GamesPlayed", LocalizationManager.GetString("GamesPlayed_Title/Text"));
             model.AddStatValue("Matches", LocalizationManager.GetString("Matches_Title/Text"));
             model.AddStatValue("RowsCleared", LocalizationManager.GetString("RowsCleared_Title/Text"));
             SetDefaults(model);
             model.UpdateStatistics = UpdateStatistics;
             return model;
             */
        };

        PyramidGameMode.GetStatKeyStatic = function () {
             var option = "";
             if (GameState.CurrentGame.GetOption("PYRAMIDTIMER") == "TRUE")
             option = "TIMED";
             return new SolitaireStatistics.StatKey(
                 GameState.CurrentGame.ActiveMode.Name,
                 (option + SolitaireGameMode.getModeById(GameState.CurrentGame.ActiveMode.Name)).toUpperCase());

        };

        PyramidGameMode.prototype.GetStatKey = function () {
            return PyramidGameMode.GetStatKeyStatic();
        };

        PyramidGameMode.prototype.UpdateStatistics = function (model) {

             //if (GameState.CurrentGame.ActiveMode.Name == SolitaireGameMode.Unknown) return;

             var statkey = PyramidGameMode.GetStatKeyStatic();

             //if (GameState.CurrentGame.GameResult == GameResult.Win)
             if(GameState.CurrentGame.Authority.BoardsCompleted() > 0)
             {
                //User Won here so update stats and save them to disk
                SolitaireStatistics.Current.UpdateGameWon(statkey);
             }
             else if (GameState.Current == GameState.GameComplete)
             {
                //User Lost here so update stats and save them to disk
                SolitaireStatistics.Current.UpdateGameLost(statkey);
             }

             //Update GameEnd Model with Latest Stats
             model["ScoreText"] =  SolitaireStatistics.Current.GetScoreFormatString(statkey);
             model["HighScore"] =  SolitaireStatistics.Current.GetHighScoreFormatString(statkey);
             model["BoardsCleared"] =  SolitaireStatistics.Current.GetStringFormat(GameState.CurrentGame.Authority.BoardsCompleted());
             model["GamesPlayed"] =  SolitaireStatistics.Current.GetGamesPlayedFormatString(statkey);
             model["LosingStreak"] =  SolitaireStatistics.Current.GetLosingStreak(statkey);

             if (GameState.CurrentGame.Authority != null)
             {
                 model["Matches"] =  SolitaireStatistics.Current.GetStringFormat(GameState.CurrentGame.Authority.Matches);
                 model["RowsCleared"] =  SolitaireStatistics.Current.GetStringFormat(GameState.CurrentGame.Authority.RowsCleared);
             }

             //UpdateLiveTile();

        };
        /*
         TODO
         private static Vector2 GetPilePostion(string key)
         {
         if (GameState.CurrentGame.SupplyView != null)
         {
         var stockPile = GameState.CurrentGame.SupplyView.CardSupply.GetPile(key);
         PileView stockPileView = GameState.CurrentGame.SupplyView.GetPileView(stockPile);
         var position = stockPileView.GetScreenPosition();
         return position;
         }
         return Vector2.Zero;
         }
         */

        PyramidGameMode.prototype.SetShare = function (args) {
            // TODO 
            /*
             var description = new StringBuilder();
             var message = new StringBuilder();
             var gameTitle = "";
             var currentAuthority = GameState.CurrentGame.Authority != null ? (Pyramid.PyramidAuthority)GameState.CurrentGame.Authority : null;
             if (currentAuthority != null)
             {
             gameTitle = LocalizationManager.GetLocalizedString("SolitaireCollection_Title/Text");
             description.Append(LocalizationManager.GetString(string.Format("Share_Description_{0}", Name.ToString())));
             message.Append(currentAuthority.Matches == 1
             ? LocalizationManager.GetString(string.Format("Share_Message_{0}_Singular",
             Name.ToString()))
             : LocalizationManager.GetString(string.Format("Share_Message_{0}", Name.ToString())));
             message.Replace("%GAME_TITLE%", gameTitle).Replace("%SCORE%",currentAuthority.Matches.ToString());
             }
             ShareManager.SetShareMessage(args,gameTitle,description,message);
             */
        };

        PyramidGameMode.prototype.UpdateLeaderBoard = function () {
            // unsupported
            /*
             var stats = SolitaireStatistics.Current;
             var statkey = GetStatKeyStatic();
             if (App.CurrentApp.GameNetClient.Settings.XblConnected)
             {
             SharedEntities.ResultObject<string> result; //string result;

             // high score
             uint lbId = SolitaireLeaderboards.Current.modeToLeaderboard[statkey.Key + SolitaireLeaderboards.HIGHSCORE];
             result = await App.CurrentApp.GameNetClient.LeaderboardManager.SaveScore((int)stats.GetHighScore(statkey), lbId, Microsoft.Xbox.Leaderboards.LeaderboardAggregation.Max);

             // rows cleared
             lbId = SolitaireLeaderboards.Current.modeToLeaderboard[statkey.Key + SolitaireLeaderboards.ROWSCLEARED];
             result = await App.CurrentApp.GameNetClient.LeaderboardManager.SaveScore((int)stats.GetRowsCleared(statkey), lbId, Microsoft.Xbox.Leaderboards.LeaderboardAggregation.Max);

             // boards cleared
             lbId = SolitaireLeaderboards.Current.modeToLeaderboard[statkey.Key + SolitaireLeaderboards.BOARDSCLEARED];
             result = await App.CurrentApp.GameNetClient.LeaderboardManager.SaveScore((int)stats.GetBoards(statkey), lbId, Microsoft.Xbox.Leaderboards.LeaderboardAggregation.Max);
             }
             */
        };

        return PyramidGameMode;

    });
